import { useMutation } from '@tanstack/react-query'
import { updateProfile } from '../index'

const useUpdateProfile = () =>
  useMutation({
    mutationFn: updateProfile,
  })

export default useUpdateProfile
